import React from 'react';
import type {
  RouteComponentProps,
  RouteProps,
  StaticContext,
} from 'react-router';
import { Route } from 'react-router';

interface ExternalStaticContext extends StaticContext {
  url?: string;
}

interface ExternalRedirectRouteProps extends RouteProps {
  render?: (
    props: RouteComponentProps<{}, ExternalStaticContext>,
  ) => React.ReactNode;
}

interface ExternalRedirectProps {
  url: string;
}

const ExternalRedirect = ({ url }: ExternalRedirectProps) => (
  <Route<ExternalRedirectRouteProps>
    render={({ staticContext }) => {
      if (staticContext) {
        // @ts-expect-error - url is added by us
        staticContext.url = url;
      } else {
        window.location.href = url;
      }

      return null;
    }}
  />
);

export { ExternalRedirect };
